import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/add_digital_role_icon.svg'
import _imports_1 from '../assets/images/add_background_icon.svg'
import _imports_2 from '../assets/images/brand-warning.png'
import _imports_3 from '../assets/images/arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-16bebcdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "digital_role_content_bg" }
const _hoisted_2 = { class: "digital_role_content" }
const _hoisted_3 = { class: "role_background_select" }
const _hoisted_4 = { class: "role_background_content_bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_name" }, "智能体形象", -1))
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "*", -1))
const _hoisted_9 = { class: "show_switch" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否在H5展示", -1))
const _hoisted_11 = { class: "role_background_content_bg" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_name" }, "智能体背景", -1))
const _hoisted_13 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "show_switch" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否在H5展示", -1))
const _hoisted_17 = { class: "kp-option-wrapper mt-40" }
const _hoisted_18 = { class: "option-item personality_setting" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "人格", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "option-item sound_setting" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "声音", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_AddRoleView = _resolveComponent("AddRoleView")!
  const _component_BackgroundSelView = _resolveComponent("BackgroundSelView")!
  const _component_DigitalInfoSetting = _resolveComponent("DigitalInfoSetting")!
  const _component_SoundSettingView = _resolveComponent("SoundSettingView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "add_digial_bg_view",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDigial && _ctx.addDigial(...args)))
          }, [
            (!_ctx.characterItem)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "character_back_img",
                  src: _ctx.characterItem.avatar,
                  alt: ""
                }, null, 8, _hoisted_7)),
            _hoisted_8,
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.characterItem ? 'click_tips_img' : 'click_tips_none_img'])
            }, _toDisplayString(_ctx.characterItem ?
                        '使用中，点击更换'
                        :
                        '请选择角色'), 3)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_switch, {
              width: "80",
              onChange: _ctx.characterShowChange,
              class: "public_switch",
              modelValue: _ctx.tempCharacterShow,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempCharacterShow) = $event)),
              "active-color": "rgb(0,0,0,0)",
              "inactive-color": "rgb(0,0,0,0)"
            }, null, 8, ["onChange", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("button", {
            class: "add_digial_bg_view add_digial_background",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addBackGround && _ctx.addBackGround(...args)))
          }, [
            (!_ctx.bgImageUrl)
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "character_back_img",
                  src: _ctx.bgImageUrl,
                  alt: ""
                }, null, 8, _hoisted_14)),
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.bgImageUrl ? 'click_tips_img' : 'click_tips_none_img'])
            }, _toDisplayString(_ctx.bgImageUrl ?
                        '使用中，点击更换' :
                        '请选择背景'), 3)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_switch, {
              width: "80",
              onChange: _ctx.backgroundShowChange,
              class: "public_switch",
              modelValue: _ctx.tempBackgroundShow,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempBackgroundShow) = $event)),
              "active-color": "rgb(0,0,0,0)",
              "inactive-color": "rgb(0,0,0,0)"
            }, null, 8, ["onChange", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "dark",
              content: "*影响您智能体的语气风格",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "option-btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editRg && _ctx.editRg(...args)))
          }, [
            _createTextVNode(" 点击配置 "),
            _hoisted_22
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "dark",
              content: "*影响您智能体的语气风格",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "option-btn",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.soundSettingClick && _ctx.soundSettingClick(...args)))
          }, [
            _createTextVNode(" 点击配置 "),
            _hoisted_27
          ])
        ])
      ])
    ]),
    (_ctx.showAddRoleView)
      ? (_openBlock(), _createBlock(_component_AddRoleView, {
          key: 0,
          onDismissAddRoleView: _ctx.dismissAddRoleView,
          onSetLinardInfoView: _ctx.setLinardInfoView,
          charactList: _ctx.charactList,
          tempCharacterId: _ctx.characterId
        }, null, 8, ["onDismissAddRoleView", "onSetLinardInfoView", "charactList", "tempCharacterId"]))
      : _createCommentVNode("", true),
    (_ctx.showBackgroundSelView)
      ? (_openBlock(), _createBlock(_component_BackgroundSelView, {
          key: 1,
          onDismissBackgroundSelView: _ctx.dismissBackgroundSelView,
          onSetLinardInfoView: _ctx.setLinardInfoView,
          tempBackgroundId: _ctx.tempBackgroundId
        }, null, 8, ["onDismissBackgroundSelView", "onSetLinardInfoView", "tempBackgroundId"]))
      : _createCommentVNode("", true),
    (_ctx.showDigitalInfoSetting)
      ? (_openBlock(), _createBlock(_component_DigitalInfoSetting, {
          key: 2,
          onDismissDigitalInfoSetting: _ctx.dismissDigitalInfoSetting,
          tempPersonality: _ctx.tempPersonality,
          careerList: _ctx.careerList,
          toneList: _ctx.toneList,
          initialCapabilityList: _ctx.initialCapabilityList
        }, null, 8, ["onDismissDigitalInfoSetting", "tempPersonality", "careerList", "toneList", "initialCapabilityList"]))
      : _createCommentVNode("", true),
    (_ctx.showSoundSetting)
      ? (_openBlock(), _createBlock(_component_SoundSettingView, {
          key: 3,
          onDismisSoundSetting: _ctx.dismisSoundSetting,
          voiceList: _ctx.voices,
          voiceId: _ctx.voiceId
        }, null, 8, ["onDismisSoundSetting", "voiceList", "voiceId"]))
      : _createCommentVNode("", true)
  ]))
}